import useJwt from '@/auth/jwt/useJwt'
import ability from '@/libs/acl/ability'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * Раздел прав -> его стартовая страница. Порядок = приоритет: первый доступный
 * раздел становится домашней страницей пользователя. Разделы без своей страницы
 * (вкладки артиста) здесь не нужны — в них попадают из списка исполнителей.
 */
const sectionHomeRoute = {
  dashboard: 'dashboard-sifnf',
  questions: 'questions',
  games: 'games',
  'fnf-league': 'fnf-league-games',
  strips: 'strips-list',
  feedback: 'feedback-stats',
  finance: 'finance',
  'author-tasks': 'author-tasks',
  players: 'players-rating',
  content: 'content-suggestions',
  generator: 'generator-packs',
  'generator-payments': 'generator-payments',
  'db-movies': 'movies',
  'db-music': 'music-dashboard',
  'artist-list': 'artists',
  'pack-review': 'pack-validate',
  users: 'admin-users',
}

/**
 * Домашний роут пользователя, выведенный из его прав.
 * Админ идёт на дефолтную страницу; остальные — на первый доступный по ability
 * раздел (на auth-login отправлять нельзя: там redirectIfLoggedIn, будет цикл).
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (!isUserLoggedIn()) return { name: 'auth-login' }
  // Админ и все, у кого есть право на сводный дэшборд, стартуют с него
  if (userRole === 'admin' || ability.can('view', 'dashboard')) return { name: 'dashboard-sifnf' }

  const section = Object.keys(sectionHomeRoute).find(s => ability.can('view', s))

  return section ? { name: sectionHomeRoute[section] } : { name: 'misc-not-authorized' }
}
